var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step",class:[!_vm.$route.meta.sidebar ? 'no-canvas' : '']},[_c('v-item-headline'),_c('v-item-refine'),_c('v-item-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }